import React, { useCallback, useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Modal } from './Modal';
import { branding } from '../config/branding';
import { useAuth } from '../context/AuthContext';
import { toastSuccess } from '../lib/toast';

export function CouponQrModal({ coupon, onClose }) {
  const { admin } = useAuth();
  const code = coupon?.code?.trim() || '';

  const modalTitle = useMemo(() => {
    const fromRow = coupon?.brandName?.trim();
    const fromSession = admin?.brandName?.trim();
    return fromRow || fromSession || branding.productName;
  }, [coupon?.brandName, admin?.brandName]);

  const copyCode = useCallback(async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      toastSuccess('Coupon code copied.');
    } catch {
      /* clipboard may be unavailable */
    }
  }, [code]);

  if (!coupon) return null;

  return (
    <Modal
      title={modalTitle}
      onClose={onClose}
      dialogClassName="coupon-qr-modal"
      footer={
        <div className="d-flex gap-2 w-100 justify-content-center">
          <button type="button" className="btn btn-outline-primary" onClick={copyCode} disabled={!code}>
            Copy code
          </button>
          <button type="button" className="btn btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      }
    >
      <div className="coupon-qr-modal__body">
        <p className="coupon-qr-modal__eyebrow mt-3">{branding.productSubtitle}</p>
        <div className="coupon-qr-modal__qr-wrap" aria-hidden={!code}>
          {code ? (
            <QRCodeSVG
              value={code}
              size={240}
              level="M"
              marginSize={2}
              bgColor="#ffffff"
              fgColor="#2d2a26"
              title={code}
            />
          ) : (
            <div className="coupon-qr-modal__qr-placeholder">No code</div>
          )}
        </div>
        <p className="coupon-qr-modal__hint">Scan to verify authenticity</p>
        <div className="coupon-qr-modal__code-block">
          <span className="coupon-qr-modal__code-label">Coupon code</span>
          <code className="coupon-qr-modal__code">{code || '—'}</code>
        </div>
      </div>
    </Modal>
  );
}
